import { render, staticRenderFns } from "./LocationSuggestions.vue?vue&type=template&id=0658762f&"
import script from "./LocationSuggestions.vue?vue&type=script&lang=js&"
export * from "./LocationSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports